import React from 'react'
import { Link } from 'react-router-dom'

export const AboutHero = () => {
  return (
    <div className='aboutHeroBg'>
        <div className='container'>
            <div className='aboutHeroTitle'>Reimagining Real Estate Bidding in India</div>
            <div className='aboutHeroSubTitle'>SnapBid is built for real buyers who want transparency, flexibility, and the freedom to choose how they purchase property.</div>
            <div className='heroBtnContainer'>
                <div className='aboutHeroContact'><Link to="/contact"><button>Contact Us</button></Link></div>
                <div className='aboutHeroBrowse'><Link to="/properties"><button>Browse Properties</button></Link></div>

            </div>

        </div>

    </div>
  )
}
